import $ from 'jquery';
import _ from 'lodash';
import { getState } from '~src/state';
import { onBackgroundChange } from '~src/image';
import { isLoggedUserGlobalEditor, getUser } from '~src/user';
import { EdgeResizer } from '~src/utils';
import differenceInDays from 'date-fns/differenceInDays';

const htmlBackgrounds = async (backgrounds) => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const { user } = await getUser();
  const { ids, html } = backgrounds.reduce(
    (acc, item) => {
      const previewImg = new EdgeResizer(item.file.url).scaleToWidth(160);

      let buttonClass = '';

      if (
        isGlobalEditor ||
        user.org_pointer.objectId === item.org_pointer?.objectId
      ) {
        buttonClass = 'editor-img-tag';
      } else {
        buttonClass = 'editor-img-tag-alone';
      }

      const itemId = `editor-sidebar-set-canvas-background-${item.objectId}`;
      let buttons = `
              <div id="editor-sidebar-sub-menu-${item.objectId}"
                class="editor-sidebar-item-image-sub-menu-container editor-sidebar-item-page">
                <button
                  class="btn btn-sidebar-images btn-sidebar-images-tag ${buttonClass}"
                  data-backgrounds-item-id="${item.objectId}"
                  data-tab-target="tab-backgrounds-tag">
                  INFO
                </button>`;

      if (
        isGlobalEditor ||
        user.org_pointer.objectId === item.org_pointer?.objectId
      ) {
        buttons += `
                    <button
                      class="btn btn-sidebar-images btn-sidebar-images-delete editor-img-delete"
                      data-delete-backgrounds-id="${item.objectId}">Elimina
                    </button>`;
      }

      buttons += '</div>';

      acc.html += '<div class="sidebar-item-grid-box image-square-container">';

      if (
        differenceInDays(new Date(), new Date(item.createdAt)) <= 30 &&
        item.isGlobal === true
      ) {
        acc.html += '<div class="sidebar-badge-new">Novità</div>';
      }

      acc.html += `
        <div
          id="${itemId}"
          data-url="${item.file.url}"
          data-background-width="${item.width || ''}"
          data-background-height="${item.height || ''}"
          class="sidebar-item-grid-box-click-listener">
        </div>`;

      if (!$(`#${itemId}`).length) {
        acc.html += `
          <img
            src="../assets/svg/img-loader.gif"
            class="lazy image-square"
            data-src="${previewImg}"
          />`;
      } else {
        acc.html += `
          <img
            src="${previewImg}"
            class="image-square"
          />`;
      }
      acc.html += `${buttons}</div>`;

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onBackgroundChange);
      $('body').on('click', id, onBackgroundChange);
    });
  }
  return html;
};

const templateAddBackgroundsDefault = async (backgrounds) => {
  const backgroundsDefault = backgrounds.filter(
    (background) => background.isGlobal === true
  );

  let html;

  if (backgroundsDefault.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non ci sono sfondi disponibili</div></div>';
  } else {
    html = await htmlBackgrounds(backgroundsDefault);
  }

  $('#editor-sidebar-backgrounds').html(html);
};

const templateAddBackgroundsCustom = async (backgrounds) => {
  const { user } = await getUser();

  const backgroundsCustom = backgrounds.filter(
    (background) =>
      background.org_pointer?.objectId === user.org_pointer.objectId
  );

  let html;

  if (backgroundsCustom.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non ci sono sfondi disponibili</div></div>';
  } else {
    html = await htmlBackgrounds(backgroundsCustom);
  }

  $('#editor-sidebar-backgrounds-custom').html(html);
};

export const displaySidebarBackgrounds = async () => {
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');

  const sidebarBackgrounds = _.get(
    window.editorConfig,
    `sidebarBackgrounds[${currentTag}]`,
    { items: [] }
  );

  await Promise.all([
    templateAddBackgroundsDefault(sidebarBackgrounds.items),
    templateAddBackgroundsCustom(sidebarBackgrounds.items),
  ]);

  window.lazyLoadInstance.update();
};
